import { Modal } from 'flowbite';
import type { ModalOptions, ModalInterface } from 'flowbite';
import { createModalHTML } from '../templates/modal-template';
import { getConfig } from '../config';
import type { GdprAction } from '../types';

export default class gdprModal {

    private modal: ModalInterface | null = null;
    private abortController: AbortController | null = null;

    /**
     * Insert modal into DOM and show it
     */
    show(onCustomize: () => void, onAction: (action: GdprAction) => void): void {
        const config = getConfig();
        if (!config) return;

        const html = createModalHTML(config);
        document.body.insertAdjacentHTML('beforeend', html);

        this.modal = this.createModal();
        if (!this.modal) return;

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        // Customize button
        document.getElementById('btn-customizer-gdpr')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
            onCustomize();
        }, { signal });

        // Accept/Decline buttons
        document.querySelectorAll<HTMLButtonElement>('.btn-dialog-gdpr[data-parent="gdprModal"]')
            .forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const action = btn.getAttribute('data-action') as GdprAction | null;
                    if (action) onAction(action);
                    this.destroy();
                }, { signal });
            });

        this.modal.show();
    }

    hide(): void {
        this.modal?.hide();
    }

    destroy(): void {
        this.abortController?.abort();
        this.abortController = null;
        this.modal?.hide();
        this.modal?.destroyAndRemoveInstance();
        this.modal = null;
        document.getElementById('gdprModal')?.remove();
    }

    private createModal(): ModalInterface | null {
        const el = document.getElementById('gdprModal');
        if (!el) return null;

        const options: ModalOptions = {
            placement: 'top-center',
            backdrop: 'dynamic',
            backdropClasses: 'hidden',
            closable: false,
            onShow: () => {
                document.body.classList.remove('overflow-hidden');
            },
        };

        return new Modal(el, options);
    }
}
